module.exports = __webpack_public_path__ + "static/2-65780774c4a3ca977827cca93fee2fd1.jpg";